// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"5207533c","222":"56797677","334":"4a50a6cb","394":"eb9d544c","453":"83e41525","534":"438fd89d","555":"89045f46","693":"a3097227","703":"a9f54809","720":"fe750b8b"}[chunkId] + ".chunk.js";
};